import Service, { service } from '@ember/service'
import type FeaturesService from 'teacher-ui-client/services/features'
import type SessionService from 'teacher-ui-client/services/session'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export default class PromoService extends Service {
  @service session!: SessionService
  @service features!: FeaturesService

  get shouldShowMSUpsell() {
    return this.session.currentSchool?.schoolSubscriptions.some(
      (sub) => sub.subscriptionName === 'ms_free_access_may_24' && sub.isActive,
    )
  }

  get shouldShowMsCrossSell() {
    return this.session.currentSchool?.schoolSubscriptions.some(
      (sub) => sub.subscriptionName === 'ms_free_access_nov_24' && sub.isActive,
    )
  }

  get shouldShowReCrossSell() {
    return this.session.currentSchool?.schoolSubscriptions.some(
      (sub) => sub.subscriptionName === 're_free_access_nov_24' && sub.isActive,
    )
  }

  get showMsRosterCrossPromo(): boolean {
    if (!this.features.isEnabled('tui_cross_promo') || !this.session.currentSchool.oneRosterEnabledAt) {
      return false
    }
    const schoolSubscriptions = this.session.currentSchool.schoolSubscriptions
    const hasActiveSub = schoolSubscriptions.find((schoolSub) => {
      return schoolSub.subscriptionType === SubscriptionType.Maths && !schoolSub.isExpired
    })

    const hasTrialSub = this.session.currentTeacher.hasTrialSubscriptionFor(SubscriptionType.Maths)
    return !hasTrialSub && !hasActiveSub
  }

  get showReRosterCrossPromo(): boolean {
    if (!this.features.isEnabled('tui_cross_promo') || !this.session.currentSchool.oneRosterEnabledAt) {
      return false
    }
    const schoolSubscriptions = this.session.currentSchool.schoolSubscriptions
    const hasActiveSub = schoolSubscriptions.find((schoolSub) => {
      return schoolSub.subscriptionType === SubscriptionType.Reading && !schoolSub.isExpired
    })

    const hasTrialSub = this.session.currentTeacher.hasTrialSubscriptionFor(SubscriptionType.Reading)
    return !hasTrialSub && !hasActiveSub
  }

  get showWlRosterCrossPromo(): boolean {
    if (!this.features.isEnabled('tui_cross_promo') || !this.session.currentSchool.oneRosterEnabledAt) {
      return false
    }
    const schoolSubscriptions = this.session.currentSchool.schoolSubscriptions
    const hasActiveSub = schoolSubscriptions.find((schoolSub) => {
      return schoolSub.subscriptionType === SubscriptionType.Writing && !schoolSub.isExpired
    })

    const hasTrialSub = this.session.currentTeacher.hasTrialSubscriptionFor(SubscriptionType.Writing)
    return !hasTrialSub && !hasActiveSub
  }

  get showMxRosterCrossPromo(): boolean {
    if (!this.features.isEnabled('tui_cross_promo') || !this.session.currentSchool.oneRosterEnabledAt) {
      return false
    }
    const schoolSubscriptions = this.session.currentSchool.schoolSubscriptions
    const hasActiveSub = schoolSubscriptions.find((schoolSub) => {
      return (schoolSub.subscriptionType as 'mathletics' | SubscriptionType) === 'mathletics' && !schoolSub.isExpired
    })

    const hasTrialSub =
      this.session.currentTeacher.teacherSubscriptions.filter(
        (sub) => (sub.subscriptionType as 'mathletics' | SubscriptionType) === 'mathletics',
      ).length > 0

    return !hasTrialSub && !hasActiveSub
  }
}
declare module '@ember/service' {
  interface Registry {
    promo: PromoService
  }
}
